// extracted by mini-css-extract-plugin
module.exports = {"title":"upload-documents_title__2VgEU","container":"upload-documents_container__2hjxQ","file":"upload-documents_file__3iwDq"};